import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

/** Register shell — Floor altitude, touch-first, minimal chrome — plan/27, 28, 35, 36 */
export function PosShell() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    function onOnline() {
      setOnline(true);
    }
    function onOffline() {
      setOnline(false);
    }
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return (
    <div className="flex h-dvh max-h-dvh flex-col overflow-hidden bg-[var(--color-background)] pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <div className="flex min-h-10 shrink-0 items-center justify-between border-b border-[var(--color-border)]/80 bg-[var(--color-shell)] px-3 py-1.5 backdrop-blur-md lg:min-h-12 lg:px-4 lg:py-2.5">
        <div className="min-w-0">
          <span className="block text-[10px] font-medium tracking-[0.08em] text-[var(--color-muted-fg)] lg:text-[11px]">
            iCraftX
          </span>
          <span className="block font-[family-name:var(--font-display)] text-base font-semibold tracking-tight text-[var(--color-foreground)] lg:text-lg">
            Register
          </span>
        </div>
        <span
          className={
            online
              ? "rounded-md bg-[color-mix(in_oklab,var(--color-ok)_14%,transparent)] px-2 py-0.5 text-[11px] font-medium text-[var(--color-ok)] lg:px-2.5 lg:py-1 lg:text-xs"
              : "rounded-md bg-[color-mix(in_oklab,var(--color-destructive)_12%,transparent)] px-2 py-0.5 text-[11px] font-medium text-[var(--color-destructive)] lg:px-2.5 lg:py-1 lg:text-xs"
          }
        >
          {online ? "Online" : "Offline — cash only"}
        </span>
      </div>
      <main className="flex min-h-0 flex-1 flex-col overflow-hidden p-2 animate-[fadeIn_220ms_ease-out] sm:p-3 lg:p-4">
        <Outlet />
      </main>
    </div>
  );
}
